var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":_vm.page.title,"icon":_vm.page.icon,"breadcrumbs":_vm.breadcrumbs}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","lg":"12"}},[_c('TheCotizacionesTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }